import { ref } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import 'element-plus/es/components/message-box/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/chat/chatList/smile.png';
const _withScopeId = n => (_pushScopeId("data-v-3740f23e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "like_container"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, null, -1));
const _hoisted_4 = {
  class: "report"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "head"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("span", null, " 期待你的反馈 ")], -1));
const _hoisted_6 = {
  class: "status"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "textarea"
};
const _hoisted_9 = ["src"];
import crownImg from '@/assets/images/chat/chatList/crown.png';
import crownHoverImg from '@/assets/images/chat/chatList/crown_hover.png';
import reportImg from '@/assets/images/chat/chatList/report.png';
import reportHoverImg from '@/assets/images/chat/chatList/report_hover.png';
import { updateComplaintStatus } from '@/api/chat';
export default /*#__PURE__*/_defineComponent({
  __name: 'likeSet',
  props: ['item', 'statusList'],
  setup(__props) {
    const props = __props;
    const itemData = ref(props.item);
    const visible = ref(false);
    const openReport = () => {
      if (itemData.value.complaintStatus == 2) {
        ElMessage.warning('您已提交举报');
        return;
      }
      visible.value = true;
    };
    const popper = ref(null);
    const outsideClick = () => {
      console.log(123);
      visible.value = false;
    };
    const close = () => {
      visible.value = false;
      complaintText.value = '';
      complaintType.value = [];
    };
    const curImg = ref();
    const mouseover = type => {
      curImg.value = type;
    };
    const mouseout = () => {
      curImg.value = '';
    };
    const complaintType = ref([]);
    const selectStatue = item => {
      if (complaintType.value.includes(item.id)) {
        const index = complaintType.value.indexOf(item.id);
        complaintType.value.splice(index, 1);
      } else {
        complaintType.value.push(item.id);
      }
    };
    // complaintText 投诉内容
    // complaintType 投诉类型：1答非所问 2回答有误 3信息过时 4没有帮助 5存在偏见 6内容违法 注意：多个数据英文逗号拼接
    // complaintStatus 投诉状态：0取消投诉 1点赞 2投诉
    const complaintText = ref('');
    const crown = async () => {
      if (itemData.value.complaintStatus == 1) return;
      if (itemData.value.complaintStatus == 2) {
        ElMessageBox.confirm('您已提交举报，是否取消举报？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          await updateComplaintStatus({
            id: props.item.id,
            complaintStatus: 0
          });
          itemData.value.complaintStatus = 0;
        }).catch(() => {});
        return;
      }
      await updateComplaintStatus({
        id: props.item.id,
        complaintStatus: 1 //0取消投诉 1点赞 2投诉
      });

      itemData.value.complaintStatus = 1;
    };
    const report = async () => {
      if (!complaintText.value) {
        ElMessage.warning('请输入举报原因！');
        return;
      }
      await updateComplaintStatus({
        id: props.item.id,
        complaintText: complaintText.value,
        complaintType: complaintType.value.join(','),
        complaintStatus: 2 //0取消投诉  2投诉
      });

      ElMessage.success('提交成功，感谢帮助');
      itemData.value.complaintStatus = 2;
      close();
    };
    return (_ctx, _cache) => {
      const _component_el_popover = _resolveComponent("el-popover");
      const _directive_click_outside = _resolveDirective("click-outside");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
        onMouseover: _cache[0] || (_cache[0] = $event => mouseover(1)),
        onMouseout: _cache[1] || (_cache[1] = $event => mouseout(1)),
        onClick: crown,
        src: _unref(itemData).complaintStatus == 1 || _unref(curImg) == 1 ? _unref(crownHoverImg) : _unref(crownImg),
        alt: ""
      }, null, 40, _hoisted_2), _hoisted_3, _createVNode(_component_el_popover, {
        "show-arrow": false,
        "popper-class": "my_popper",
        placement: "top-end",
        trigger: "click",
        visible: _unref(visible),
        ref_key: "popper",
        ref: popper
      }, {
        reference: _withCtx(() => [_createElementVNode("img", {
          onMouseover: _cache[3] || (_cache[3] = $event => mouseover(2)),
          onMouseout: _cache[4] || (_cache[4] = $event => mouseout(2)),
          class: "report_icon",
          onClick: openReport,
          src: _unref(itemData).complaintStatus == 2 || _unref(curImg) == 2 ? _unref(reportHoverImg) : _unref(reportImg),
          alt: ""
        }, null, 40, _hoisted_9)]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.statusList, (vo, index) => {
          return _openBlock(), _createElementBlock("div", {
            onClick: $event => selectStatue(vo),
            key: index,
            class: _normalizeClass(["item", {
              item_select: _unref(complaintType).includes(vo.id)
            }])
          }, _toDisplayString(vo.name), 11, _hoisted_7);
        }), 128))]), _createElementVNode("div", _hoisted_8, [_withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(complaintText) ? complaintText.value = $event : null),
          placeholder: "期待您的反馈和意见让我持续成长",
          maxlength: "200",
          name: "",
          id: "",
          cols: "30",
          rows: "10"
        }, null, 512), [[_vModelText, _unref(complaintText), void 0, {
          trim: true
        }]])]), _createElementVNode("div", {
          class: "footer"
        }, [_createElementVNode("div", {
          class: "btn cancel",
          onClick: close
        }, "取消"), _createElementVNode("div", {
          class: "btn submit",
          onClick: report
        }, "提交")])])), [[_directive_click_outside, outsideClick]])]),
        _: 1
      }, 8, ["visible"])]);
    };
  }
});